const ScheduleIcon = ({ isSelect }: { isSelect: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.76918 3H18.2307C19.7538 3 21 4.24615 21 5.76923V14.0769C21 15.6014 19.7538 16.8462 18.2307 16.8462H16.8461V20L12.6923 16.8462H2.99995V5.76923C2.99995 4.24615 4.24611 3 5.76918 3ZM8.84993 13.5V5.99997H10.4249V9.21425H13.5749V5.99997H15.1499V13.5H13.5749V10.2857H10.4249V13.5H8.84993ZM7.4287 11.7359C7.33024 11.6355 7.27493 11.4992 7.27493 11.3571V10.2857H6.74993V9.21425H7.27493V8.14283C7.27493 8.00074 7.33024 7.86448 7.4287 7.76402C7.52715 7.66355 7.66069 7.60711 7.79993 7.60711H8.32493V11.8928H7.79993C7.66069 11.8928 7.52715 11.8364 7.4287 11.7359ZM16.5712 7.76402C16.6696 7.86448 16.7249 8.00074 16.7249 8.14283V9.21425H17.2499V10.2857H16.7249V11.3571C16.7249 11.4992 16.6696 11.6355 16.5712 11.7359C16.4727 11.8364 16.3392 11.8928 16.1999 11.8928H15.6749V7.60711H16.1999C16.3392 7.60711 16.4727 7.66355 16.5712 7.76402Z"
        fill={isSelect}
      />
    </svg>
  );
};

export default ScheduleIcon;
